<template>
  <div class="blackList-box">
    <!--操作栏-->

    <div class="action-bar">
      <el-input
        v-model.number="params.uid"
        placeholder="请输入用户ID"
        size="small"
        clearable
        class="param-input"
      ></el-input>
      <el-input
        v-model.trim="params.content"
        placeholder="请输入关键字"
        size="small"
        clearable
        class="param-input"
      ></el-input>
      <el-button type="primary" size="small" @click="search('status')"
        >搜索</el-button
      >
    </div>

    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="650"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="关键字" align="center" width="300">
        <template slot-scope="scope">
          <span v-html="scope.row.content.replace(/\n/g, '<br/>')"></span>
        </template>
      </el-table-column>
      <el-table-column prop="imageUrl" label="图片" align="center" width="200">
        <template slot-scope="scope">
          <div v-if="!scope.row.imageUrl.length">-</div>
          <div
            v-else
            class="picturePreview"
          >
            <decrypt-img
              style="width: 50px; height: 50px"
              :src="imgUrl + item"
              fit="fill"
              v-for="(item, i) in scope.row.imageUrl"
              :key="i"
            ></decrypt-img>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="版本号"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.version || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="devType"
        label="设备型号"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.devType || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="action(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="remove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--编辑反馈信息弹窗-->
    <edit-feedback
      ref="editFeedback"
      @handlerAddblack="getFeedbackList"
    ></edit-feedback>
    <!-- 图集预览窗口 -->
    <preview-picture
      ref="previewPicture"
      @handlerPreviewList="handlerPreviewList"
    ></preview-picture>
  </div>
</template>
<script>
import { paramsFilter } from "@/utils/global";
import EditFeedback from "./components/editFeedback";
import PreviewPicture from "./components/previewPicture";
import baseConfig from "@/utils/serverUrlConfig";

import API from "@/api";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      // 反馈信息类型
      blackType: [
        {
          label: "IP",
          value: "IP",
        },
      ],
      // 用户管理列表请求参数
      params: {
        type: "",
        content: "",
        pageNumber: 1,
        pageSize: 10,
      },
      imgUrl: baseConfig.imgUrl,
    };
  },
  components: {
    EditFeedback,
    PreviewPicture,
  },
  created() {
    this.getFeedbackList();
  },
  methods: {
    // 请求反馈信息列表
    getFeedbackList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      let params = paramsFilter(this.params);
      API.getFeedbackList(params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 新增、修改tags
    action(type) {
      this.$refs.editFeedback.open(type);
    },
    // 删除
    remove(row) {
      this.$confirm("您确定要删除当前反馈信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.delFeedback({ ids: [row.id] }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除反馈信息成功",
                type: "success",
              });
              this.getFeedbackList();
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {});
    },
    // 图集预览
    previewPicture(pictureArr, id, tags) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id, tags);
    },
    handlerPreviewList() {
      this.getFeedbackList();
    },
    // 搜索对应列表
    search(type) {
      this.params.pageNumber = 1;
      this.getFeedbackList(type);
    },
    // 监听新增成功回掉
    getAddblack() {
      this.getFeedbackList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getFeedbackList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getFeedbackList();
    },
  },
};
</script>
<style lang="scss"></style>
